import { CAR_DETAIL_UPDATE,CITY_DETAIL_LIST,CHAKBOX_LIST,ADDRESS_FORM, DOST_PROGRAM, VEHICLE_FEATURE_SAVE_SETTLED} from "../constant/index";
import { buildDivindexFromVehicleDetails } from "../utils/vehicleDetails";

const INITIAL_STATE = {
  loading: true,
  data:[],
  productlist:[],
  dost_loading: false,

  step2complete:false,
  cityAddress:{},
  vehicle_data:{},

  divindex:{},

  addressform:false,
  addressformCreate:false,
  addressformFailedAt: 0,
  addressformSuccessAt: 0,
  addressFormErrors: {},
  featureSaveSettledAt: 0,

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${DOST_PROGRAM}_REQUEST`:
      return { dost_loading: true };
    case `${DOST_PROGRAM}_SUCCESS`:
      // console.log("DOST_PROGRAM ...........DOST_PROGRAM", action.payload)
      return { dost_loading: false };
    case `${DOST_PROGRAM}_FAIL`:
      return { dost_loading: false };
    case `${DOST_PROGRAM}_ERROR`:
      return { dost_loading: false };
    case 'CAR_DETAIL_SETUP':
      // console.log("i am in car update detai-->> ",action.payload.data_vehicle)
      var d = action.payload.data;
      return {
        ...state,
        vehicle_data: action.payload.data_vehicle,
        divindex: buildDivindexFromVehicleDetails(
          d.vehcile_details,
          action.payload.questions || []
        ),
      };
    case `${CAR_DETAIL_UPDATE}`:
      // console.log("i am in car update detai-->> ",action.payload.data_vehicle)
      return { ...state, vehicle_data: action.payload.data_vehicle };
    case `${CAR_DETAIL_UPDATE}_REQUEST`:
      if (action.meta?.silent) {
        return state;
      }
      return { ...state, loading: true };
    case `${CAR_DETAIL_UPDATE}_SUCCESS`:
      console.log(
        "CAR_DETAIL_UPDATE ...........CAR_DETAIL_UPDATE",
        action.payload
      );
      const questions = action.payload || [];
      const restoredDivindex = buildDivindexFromVehicleDetails(
        state.vehicle_data?.vehcile_details,
        questions
      );

      return {
        ...state,
        data: action.payload,
        loading: false,
        divindex: restoredDivindex,
      };
    case `${CAR_DETAIL_UPDATE}_FAIL`:
      return { ...state, loading: false };
    case `${CAR_DETAIL_UPDATE}_ERROR`:
      return { ...state, loading: false };
    //
    // =======================addrss form====================

    case `${ADDRESS_FORM}_REQUEST`:
      return { ...state, addressFormErrors: {} };
    case `${ADDRESS_FORM}_SUCCESS`:
      // console.log("CAR_DETAIL_UPDATE ...........CAR_DETAIL_UPDATE",action.payload)

      return {
        ...state,
        addressform: true,
        step2complete: true,
        addressformCreate: true,
        addressformSuccessAt: Date.now(),
        addressFormErrors: {},
        loading: false,
      };
    case `${ADDRESS_FORM}_FAIL`:
      return {
        ...state,
        loading: false,
        addressformFailedAt: Date.now(),
        addressFormErrors: action.payload?.errors || {},
      };
    case `${ADDRESS_FORM}_ERROR`:
      return {
        ...state,
        loading: false,
        addressformFailedAt: Date.now(),
        addressFormErrors: {},
      };
    case VEHICLE_FEATURE_SAVE_SETTLED:
      return {
        ...state,
        featureSaveSettledAt: Date.now(),
      };
    //
    // =======================product sale list====================

    case CITY_DETAIL_LIST:
      // console.log("CAR_DETAIL_UPDATE ...........CAR_DETAIL_UPDATE",action.payload)

      return {
        cityAddress: action.payload.data,
      };
    case CHAKBOX_LIST:
      // console.log("checkbox_list ...........checkbox_list",action.payload," state ====> ",state)
      const f = { ...state.divindex };
      f[action.payload.data.index] = action.payload.data.div;
      // return f
      return {
        ...state,

        divindex: f,
      };
    case "HYDRATE_VEHICLE_DIVINDEX":
      return {
        ...state,
        divindex: action.payload.divindex,
      };
  }




//   switch (action.type) {
//     case `${CAR_DETAIL_UPDATE}`:
//       // console.log("i am in car update detai-->> ",action.payload.data_vehicle)
//       return { ...state, vehicle_data: action.payload.data_vehicle };
//     case `${CAR_DETAIL_UPDATE}_REQUEST`:
//       return { ...state, loading: true };
//     case `${CAR_DETAIL_UPDATE}_SUCCESS`:
//       // console.log("CAR_DETAIL_UPDATE ...........CAR_DETAIL_UPDATE in succcess",action.payload)
//       var f={}
//       // console.log("vehicle details in moduue0---------------->> ",state.vehicle_data)
//       for(var i=0;i<state.vehicle_data.vehcile_details.length;i++){
//         f[i]=state.vehicle_data.vehcile_details[i].feature.map((item,index)=>item.id)
//       }
//       // console.log("div setting --> ",f)
//       return { ...state, 
//         data:action.payload,
//         loading:false,
//         divindex:f
//       };
//     case `${CAR_DETAIL_UPDATE}_FAIL`:
//       return { ...state, loading: false };
//     case `${CAR_DETAIL_UPDATE}_ERROR`:
//       return { ...state, loading: false };
//     //
//   // =======================product sale list====================
  







// }







  return state;
};
